export default {
  computed: {
    priceType() {
      return {
        isSecondPrice: window.isSecondPrice
      };
    }
  }
};
